import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './queryRecordController.json';

const SIMULATED_DELAY_MS = 5000;

const queryCollectionServiceSettings = async (req, res, ctx) => {
  await new Promise((resolve) => setTimeout(resolve, SIMULATED_DELAY_MS));
  const resData = apiResponses['queryRecordDashboardController/queryCollectionServiceSettings'];
  return res(ctx.json(mockResponse(resData.success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('queryRecordDashboardController/queryCollectionServiceSettings'),
    withScenario(withAuthCheck(queryCollectionServiceSettings))
  ),
];
